/**
 * Format price in French TTC format with 2 decimal places
 * Example: 19.9 -> "19,90 € TTC"
 * 
 * @param {number} price - The price to format
 * @param {boolean} showTTC - Whether to append "TTC" (default: true)
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, showTTC = true) => {
  if (price === null || price === undefined || isNaN(price)) {
    return showTTC ? '0,00 € TTC' : '0,00 €';
  }
  
  const formatted = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
  
  return showTTC ? `${formatted} € TTC` : `${formatted} €`;
};

/**
 * Format price for display without currency symbol (for inputs, calculations)
 * @param {number} price - The price to format
 * @returns {string} Formatted price string without symbol
 */
export const formatPriceNumber = (price) => {
  if (price === null || price === undefined || isNaN(price)) {
    return '0,00';
  }
  
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

export default formatPrice;
